export const createActionTypes = <T extends { [key: string]: string }>(name: string, types: T): T => Object.entries(types)
  .reduce((object, [key, value]) => {
    return {
      ...object,
      [key]: `${name}/${value}`
    }
  }, types)